import { useTheme } from '@mui/styles';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    root: {
      display: 'grid',
      gridTemplateColumns: '1fr 2fr',
      gridTemplateAreas: '"employeeData employmentData"',
      gridGap: theme.spacing(2),
      maxWidth: '1300px',
    },
    employeeData: {
      gridArea: 'employeeData',
    },
    employmentData: {
      gridArea: 'employmentData',
    },
    loading: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
    },
  };
};
